import React, { useState, useEffect } from 'react';
import { Button, Col, Modal, Row } from 'antd';
import { API, getData, usuario } from '../../resources';

import DetalleHistoria from './detalleHistoria';
import DetallesPaciente from '../pacientes/detalles.paciente';
import { PrinterOutlined, CloudDownloadOutlined } from '@ant-design/icons'
// import ExpedienteDocument from './expedienteForPrint';
import Loading from '../../loading';
import nodata from '../../assets/no-data.png'
import Visitas from './visitas';
import Recetas from './recetas';
import LastCita from './lastCita';

import HojasEnfermeriaNext from './hojasEnfermeriaNext';
import ExpedienteForPrintNext from './printed-docs/expedienteForPrintNext';
import { ConscentKetaminaModalDocument } from './printed-docs/conscent-ketamina';
import { ConscentEsketaminaModalDocument } from './printed-docs/conscent-esketamina';
import { ConscentEMTModalDocument } from './printed-docs/conscent-emt';
import ExpedientesLegacyModal from './expedientes-leagcy-modal';
// import ExpedienteDocument from './expedienteForPrint';
// import html2canvas from 'html2canvas'; deprecated
// import { jsPDF } from "jspdf";

// Parent : Pacientes/main pacientes
// Parent recepcion: pacientes-next/index -> click paciente -> expediente
// Receocionista -> puede crear expediente pero no puede agregar datos, solo verlos
// Medico -> puede crear expediente, agregar datos y verlos

export default function Expedientes({ paciente = {}, setIsEditModalOpen }) {

    const [expedientesData, setExpedientesData] = useState(null);
    const [expedientesLoading, setExpedientesLoading] = useState(true);
    const [historia, setHistoria] = useState("");
    const [historiaDetails, sethistoriaDetails] = useState([])
    const [notas, setNotas] = useState("");
    const [recetas, setRecetas] = useState("");
    const [citas, setcitas] = useState("")
    const [hojasEnfermeria, setHojasEnfermeria] = useState([])
    const [visitas, setVisitas] = useState([])
    const [hojasEmt, setHojasEmt] = useState([])
    const [escalasData, setEscalasData] = useState([])

    // Print modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    // Print modal end

    const { _id: id_paciente } = paciente;

    useEffect(() => {
        getExpedientesData(id_paciente)
    }, [id_paciente])

    // Los datos del modal de impresión solo se necesitan al abrirlo
    useEffect(() => {
        if (isModalOpen) getPatientRegisters(id_paciente)
    }, [isModalOpen, id_paciente])


    const getExpedientesData = (id_paciente) => {
        // console.log('Received patient exp doc ', id_paciente)
        fetch(API + `expedientes/${id_paciente}`)
            .then(response => response.json())
            .then(data => {
                // console.log("GetExpData: ", data);
                setExpedientesData(data);
                if (typeof data != "undefined" && data !== null) {
                    // setNotas(data.notas);
                    setHistoria(data.historia);
                } else { setNotas(null); setHistoria(null) }
            })
            .finally(() => setExpedientesLoading(false))
    }

    const getPatientRegisters = (id_paciente) => {
        getData(`notas/${id_paciente}`).then(rs => setNotas(rs))
        getData(`receta/${id_paciente}`).then(rs => setRecetas(rs))
        getData(`citas/${id_paciente}`).then(rs => setcitas(rs))
        getData(`hojas/${id_paciente}`).then(rs => setHojasEnfermeria(rs || []))
        // Historia clínica: por paciente (`historia/:_id` está deprecado)
        getData(`historias/${id_paciente}`).then(rs => sethistoriaDetails(Array.isArray(rs) ? rs : []))
        getData(`visitas/${id_paciente}`).then(rs => {
            const visitasData = rs || []
            setVisitas(visitasData)
            // Fetch hojas de registro EMT for each EMT visita
            const emtVisitas = visitasData.filter(v => v.tipo_visita === 'tratamiento_emt')
            Promise.all(emtVisitas.map(v =>
                getData(`hojas-emt/${v._id}/${id_paciente}`).then(hoja => hoja ? { ...hoja, visita: v } : null)
            )).then(hojas => setHojasEmt(hojas.filter(Boolean)))
            // Fetch escalas for EMT visitas (sessions 1,3,5,7)
            const escalasPromises = emtVisitas.flatMap(v =>
                [1, 3, 5, 7].map(session =>
                    getData(`encuestas/table/${id_paciente}/${v._id}/${session}`)
                        .then(data => (data && Array.isArray(data) && data.length > 0) ? data.map(d => ({ ...d, session, visita_id: v._id })) : [])
                )
            )
            Promise.all(escalasPromises).then(results => setEscalasData(results.flat()))
        })
    }

    const Hub = () => {
        return (
            <div style={{ padding: '20px 24px', marginTop: 20, borderRadius: 12, backgroundColor: 'white', boxShadow: '0 1px 6px rgba(0,0,0,0.07)' }}>
                <Row gutter={16}>
                    <Col span={7} style={{ borderRight: '1px solid #f0f0f0' }}>
                        {usuario?.rol === 'Medico' && <Recetas id_paciente={id_paciente} />}
                        <LastCita paciente={id_paciente} />
                        <HojasEnfermeriaNext id_paciente={id_paciente} datosPaciente={paciente} />
                    </Col>
                    <Col span={17}>
                        <Visitas id_paciente={id_paciente} pacienteData={paciente} />
                    </Col>
                </Row>
            </div>
        )
    }

    const EnoENT = () => (
        <div style={{ marginBottom: 30, marginTop: 20, backgroundColor: 'white', paddingTop: 50, paddingBottom: 50, borderRadius: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={nodata} style={{ width: 80, height: 80 }} />
                <span style={{ fontSize: 28, fontWeight: 400, color: '#4a555e' }}>Sin expediente</span>
            </div>
        </div>
    )

    if (expedientesLoading) return <Loading />

    // if (!expedientesData) return <EnoENT />

    return <div id='expedient-export' >

        {/* <h4 className='spacedTitle'>Expediente </h4> */}

        <div style={{ display: 'flex', flexDirection: 'row', gap: 15 }}>
            <DetallesPaciente paciente={paciente} setIsEditModalOpen={setIsEditModalOpen} />

            <DetalleHistoria historia={historia} detalles_paciente={paciente} />



        </div>

        <Hub />


        <Button onClick={showModal} style={{ marginTop: 6 }}  >🖨️ Imprimir expediente</Button>
        <ExpedientesLegacyModal id_paciente={id_paciente} />

        <div style={{ display: 'flex', flexDirection: 'row', gap: 10, marginTop: 6 }}>

            <ConscentKetaminaModalDocument pacienteData={paciente} buttonText="Consentimiento de Ketamina" />
            <ConscentEsketaminaModalDocument pacienteData={paciente} buttonText="Consentimiento de Esketamina" />
            <ConscentEMTModalDocument pacienteData={paciente} buttonText="Consentimiento de EMT" />
            {/* Download button here */}
        </div>


        <Modal title="Imprimir Expediente" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={900}>
             <ExpedienteForPrintNext
                data={paciente}
                historyText={historiaDetails}
                citas={citas || []}
                hojasEnfermeria={hojasEnfermeria}
                visitas={visitas}
                hojasEmt={hojasEmt}
                escalasData={escalasData}
            />
        </Modal>


    </div>;
}
